// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({"182": "gsap-vendor","460": "quickjs-sandbox",}[chunkId] || chunkId) + "." + {"182": "9170b3a247f302b2","396": "078d71d91bc91373","460": "6e307294ae56b7f2","917": "5e9c18e3cd2f49e1","985": "4e7ec513dfacf4ba",}[chunkId] + ".chunk.js"
}